import { formatarMoeda } from '../lib/formatos'

// O sinal e o nome do ajuste (debito/credito) num so lugar: rodape, quadro do
// topo e PDF escreviam cada um o seu, e o zero saia "Débito" na tela e
// "Crédito" no PDF. "−" e o sinal de menos tipografico, o mesmo da tela.
export const sinal = (v: number) => (v > 0 ? '+' : v < 0 ? '−' : '')

export function rotuloDoAjuste(v: number): 'Débito' | 'Crédito' | 'Débito/Crédito' {
  return v < 0 ? 'Débito' : v > 0 ? 'Crédito' : 'Débito/Crédito'
}

export function valorComSinal(v: number): string {
  return `${v === 0 ? '' : `${sinal(v)} `}${formatarMoeda(Math.abs(v))}`
}
